angular.module('tgaAdmin').controller('HubController', [
  '$scope',
  '$state',
  '$location',
  '$window',
  '$uibModal',
  'hubService',
  'customFieldService',
  'playerListService',
  'SSOProviderService',
  'Slug',
  'flashService',
  'Papa',
  'modalService',
  'gameService',
  'urlService',
  'divisionService',
  'settingsService',
  '$log',
  '$timeout',
  'domainService',
  '$translate',
  function (
    $scope,
    $state,
    $location,
    $window,
    $uibModal,
    hubService,
    customFieldService,
    playerListService,
    SSOProviderService,
    Slug,
    flashService,
    Papa,
    modalService,
    gameService,
    urlService,
    divisionService,
    settingsService,
    $log,
    $timeout,
    domainService,
    $translate,
  ) {
    $scope.showBack = $state.current.data.back;

    $scope.data = {
      alerts: [],
      authorizationType: [
        {
          id: 2,
          name: 'Single Sign-On',
        },
        {
          id: 3,
          name: 'Direct Registration',
        },
        {
          id: 0,
          name: 'Custom Registration',
        },
      ],
      scormCompletionOptions: [
        {
          id: 1,
          name: 'Always Complete',
        },
        {
          id: 2,
          name: 'Never Complete',
        },
        {
          id: 3,
          name: 'Based on User Level',
        },
      ],
      weeklyEmailIntervalOptions: [
        {
          id: 'weekly',
          name: 'Weekly',
        },
        {
          id: 'monthly',
          name: 'Monthly',
        },
      ],
      truncateNameOptions: [
        {
          id: 1,
          name: 'First Name, Last Initial',
        },
        /* {
          id: 2,
          name: 'First Initial, Last Name',
        }, */
        {
          id: 3,
          name: 'First Name Only',
        },
      ],
      hubId: $state.params.hub_id || null,
      playerLists: [],
      ssoProviders: [],
      url: urlService.composeProtocolHostPort($location),
      domain: domainService.domain,
    };

    $scope.doceboUploadProcessing = false;
    $scope.showDoceboPublish = false;

    // Dynamic add for ui-select
    $scope.tagSelectItem = function (value, division) {
      const item = {
        division_id: division.division_id,
        division_option_id: null,
        value,
        label: `Add New ${division.name}`,
        labelSelected: `New ${division.name}`,
      };

      division.value = value;

      return item;
    };

    $scope.refreshSelect = function (selectObject, division) {
      if (!division.allow_add) {
        return;
      }

      if (selectObject.search) {
        if (selectObject.items.length === 0) {
          selectObject.items.push($scope.tagSelectItem(selectObject.search, division));
        } else if (selectObject.items.length === 1 && selectObject.items[0].division_option_id === null) {
          selectObject.items[0] = $scope.tagSelectItem(selectObject.search, division);
        }
      } else if (selectObject.items.length === 1 && selectObject.items[0].division_option_id === null) {
        selectObject.items = [];
      }
    };

    $scope.viewmodel = {
      hub_id: $scope.data.hubId,
      authorization_type: null,
      name: null,
      player_lists: [],
      custom_fields: [],
      slug: null,
      sso_provider_id: null,
      player_list_id: null,
      challenge_email: false,
      weekly_email: false,
      weekly_email_interval: 'weekly',
      email_logo: null,
      from_name: null,
      from_email: null,
      daily_xp_limit: false,
      session_timeout: 3600,
      scorm_completion_type: 1,
      scorm_completion_level: null,
      leaderboard_enabled: true,
      spintowin_enabled: true,
      achievements_enabled: true,
      ratings_enabled: false,
      ratings_admin: false,
      feedback_enabled: false,
      feedback_email: null,
      display_arcade_name: false,
      truncate_names_enabled: false,
      truncate_names_type: null,
      divisions: [],
      oreg_confirm_checkbox: false,
      oreg_required_checkbox: false,
    };

    $scope.initialize = function () {
      $scope.loading = true;
      domainService.getDomain().then((d) => {
        $scope.showDoceboPublish = d.docebo_sa_id && d.docebo_subdomain && d.docebo_client_app_id;
        settingsService.getSettings().then((settings) => {
          $scope.data.settings = settings;
          if (settings.open_reg_tga) {
            $scope.data.authorizationType[$scope.data.authorizationType.length] = {
              id: 4,
              name: 'Open Registration (TGA)',
            };
          }
        });
      });

      const promises = [];

      promises.push(
        playerListService.getPlayerLists().then((playerLists) => {
          $scope.data.playerLists = playerLists;
        }),
      );

      promises.push(
        SSOProviderService.getSSOProviders().then((ssoProviders) => {
          $scope.data.ssoProviders = ssoProviders;
        }),
      );

      if ($scope.data.hubId) {
        promises.push(
          hubService.getHub($scope.data.hubId).then((hub) => {
            $scope.viewmodel = { ...$scope.viewmodel, ...angular.copy(hub) };
            $scope.title = `<span class="text-muted">Arcades / ${hub.name} /</span> Settings`;

            // Get divisions
            divisionService.getDivisions(false, true).then((divisions) => {
              divisions.forEach((division) => {
                if (hub.divisions[division.key].division_option_id) {
                  division.division_option_id = hub.divisions[division.key].division_option_id;
                }
              });

              $scope.viewmodel.divisions = divisions;
            });
          }),
        );
      } else {
        divisionService.getDivisions(false, true).then((divisions) => {
          $scope.viewmodel.divisions = divisions;
        });
      }

      Promise.all(promises)
        .catch((err) => {
          $log.warn(err);
        })
        .finally(() => {
          $scope.loading = false;
        });
    };

    $scope.actions = {
      removePlayerList(list) {
        const index = $scope.viewmodel.player_lists.indexOf(list);
        $scope.viewmodel.player_lists.splice(index, 1);
      },
      deleteHub() {
        modalService
          .showModal(
            {
              title: 'Delete Arcade?',
              message: 'Are you sure you want to delete this arcade?',
              closeButton: 'No',
              actionButton: 'Yes',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(
            () => {
              $scope.deleting = true;

              hubService
                .deleteHub({
                  hub_id: $scope.data.hubId,
                  is_deleted: 1,
                })
                .then(
                  () => {
                    flashService.set('<span class="fa fa-check"></span> Arcade deleted.', 'success');
                    $state.go('v1.hubs');
                  },
                  (error) => {
                    $scope.actions.createAlert(
                      `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                      'danger',
                    );
                    $scope.deleting = false;
                  },
                );
            },
            () => {},
          );
      },
      addPlayerList() {
        $scope.hubForm.player_list_id.$setValidity('required', true);

        const idToCheck = $scope.viewmodel.player_list_id;

        // make sure there is no duplicate
        const inList = $scope.viewmodel.player_lists.some((list) => list.player_list_id === idToCheck);

        if (!inList) {
          const list = $scope.data.playerLists.find((l) => l.player_list_id === idToCheck);

          $scope.viewmodel.player_lists.push(list);
        }

        $scope.viewmodel.player_list_id = null;
      },
      selectAuthorizationType() {
        switch ($scope.viewmodel.authorization_type) {
          case 1:
            $scope.viewmodel.sso_provider_id = null;
            break;
          case 2:
            break;
          case 0:
          default:
            $scope.viewmodel.player_list_id = null;
            $scope.viewmodel.sso_provider_id = null;
            $scope.viewmodel.player_lists = [];
            break;
        }
      },
      fixSlug() {
        if ($scope.viewmodel.slug) {
          $scope.viewmodel.slug = Slug.slugify($scope.viewmodel.slug);
        }
      },
      makeSlug() {
        if (!$scope.viewmodel.slug) {
          $scope.viewmodel.slug = Slug.slugify($scope.viewmodel.name);
        }
      },
      copyUrl() {
        const url = `${$scope.data.url}/arcade/${$scope.viewmodel.slug}`;

        return url;
      },
      copySuccess(name) {
        if ($scope.copyTimer) {
          $timeout.cancel($scope.copyTimer);
        }

        $scope.data.copied = name;

        $scope.copyTimer = $timeout(() => {
          $scope.data.copied = false;
        }, 1500);
      },
      publishToDocebo() {
        $scope.doceboUploadProcessing = true;
        const { hub_id } = $scope.viewmodel;
        const { domain } = domainService;
        hubService.publishToDocebo({
          hub_id,
          domain,
        })
          .then(() => {
            $scope.actions.createAlert('<span class="fa fa-check"></span> Published to Docebo successfully.', 'success');
          })
          .catch((error) => {
            if (error.message) {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
            } else {
              $scope.actions.createAlert(
                '<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> There was an error processing your request.',
                'danger',
              );
            }
          })
          .finally(() => {
            $scope.doceboUploadProcessing = false;
          });
      },
      downloadScorm(version, lms) {
        let url = hubService.getScormUrl($scope.viewmodel.hub_id, version);
        if (lms) {
          url += `&lms=${lms}`;
        }
        $window.open(url);
      },
      submit(form) {
        $scope.submitted = true;

        $scope.data.alerts = [];

        if ($scope.viewmodel.authorization_type === 1 && $scope.viewmodel.player_lists.length < 1) {
          form.player_list_id.$setValidity('required', false);
        }

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        $scope.processing = true;

        if ($scope.viewmodel.hub_id) {
          hubService
            .updateHub($scope.viewmodel)
            .then(
              () => {
                flashService.set('<span class="fa fa-check"></span> Arcade updated.', 'success');
                $state.reload('v1.hub.edit');
              },
              (error) => {
                $scope.actions.createAlert(
                  `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                  'danger',
                );
              },
            )
            .finally(() => {
              $scope.processing = false;
            });
        } else {
          hubService.addHub($scope.viewmodel).then(
            (hub) => {
              flashService.set('<span class="fa fa-check"></span> Arcade created.', 'success');
              $state.go('v1.hub.activities', { hub_id: hub.hub_id });
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              $scope.processing = false;
            },
          );
        }
      },
      checkImage(image) {
        if (!image) {
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        const extension = /(?:\.([^.]+))?$/;
        const ext = extension.exec(image.filename)[1];
        const allowed = /jpeg|jpg|gif|png|svg/i;
        if (!allowed.test(ext)) {
          image.base64 = null;
          image = null;
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        // Don't allow images larger than 5MB.
        if (image.filesize > 5242880) {
          image.base64 = null;
          image = null;
          $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Image files cannot be more than 5 MB in size.',
            'danger',
          );
        }
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
    };

    $scope.initialize();
  },
]);
